import type { Principle } from '../types/content';

export const employerCommitments: Principle[] = [
  {
    title: 'A shortlist worth your time',
    description: 'Typically four to six rigorously assessed, genuinely interested candidates — never a stack of CVs.',
  },
  {
    title: 'Clear market intelligence',
    description: 'Compensation benchmarks, talent availability, and competitor insight shared as the search unfolds.',
  },
  {
    title: 'Confidential handling',
    description: 'Discreet approaches that protect your organization, your incumbents, and your strategy.',
  },
  {
    title: 'A guarantee on appointments',
    description: 'We stand behind every placement and remain engaged through the new leader’s first year.',
  },
];

export const engagementModels: Principle[] = [
  {
    title: 'Retained executive search',
    description: 'Our core service for board, C-suite, and senior leadership roles, run by a dedicated partner-led team.',
  },
  {
    title: 'Leadership assessment',
    description: 'Independent evaluation of internal candidates or full leadership teams ahead of key decisions.',
  },
  {
    title: 'Interim leadership',
    description: 'Rapid access to experienced executives for transformation, turnaround, or leadership gaps.',
  },
  {
    title: 'Succession advisory',
    description: 'Ongoing partnership to build a resilient pipeline for the roles that matter most.',
  },
];
